<template>
  <div>
    <div class="container td-admin-container">
      <div class="row td-message-row">
        <div class="col s6 offset-s3">
          <h4>{{ message }}</h4>
        </div>

      </div>
      <div class="row">
        <div class="col s12">
          <form @submit.prevent="onSubmitRegistration">
            <div class="col s4">
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="user_login"
                    v-model.trim="login"
                    type="text"
                    class="validate"
                  >
                  <label for="user_login">User Login</label>
                  <span v-if="$v.login.$dirty && !$v.login.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="user_password"
                    v-model.trim="password"
                    type="password"
                    class="validate"
                  >
                  <label for="user_password">User Password</label>
                  <span v-if="$v.password.$dirty && !$v.password.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="Salutation"
                    v-model.trim="salutation"
                    type="text"
                    class="validate"
                  >
                  <label for="Salutation">Salutation</label>
                  <span v-if="$v.salutation.$dirty && !$v.salutation.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="First Name"
                    v-model.trim="first_name"
                    type="text"
                    class="validate"
                  >
                  <label for="First Name">First Name</label>
                  <span v-if="$v.first_name.$dirty && !$v.first_name.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="Last Name"
                    v-model.trim="last_name"
                    type="text"
                    class="validate"
                  >
                  <label for="Last Name">Last Name</label>
                  <span v-if="$v.last_name.$dirty && !$v.last_name.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
            </div>
            <div class="col s4">
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="Date of Birth"
                    v-model.trim="date_of_birth"
                    type="text"
                    class="validate"
                  >
                  <label for="Date of Birth">Date of Birth</label>
                  <span v-if="$v.date_of_birth.$dirty && !$v.date_of_birth.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="Email Address"
                    v-model.trim="email"
                    type="text"
                    class="validate"
                  >
                  <label for="Email Address">Email Address</label>
                  <span v-if="$v.email.$dirty && !$v.email.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                  <span v-if="$v.email.$dirty && !$v.email.email" class="helper-text" data-error="wrong" >Invalid Email</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="Company Name"
                    v-model.trim="company_name"
                    type="text"
                    class="validate"
                  >
                  <label for="Company Name">Company Name</label>
                  <span v-if="$v.company_name.$dirty && !$v.company_name.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="Phone Number"
                    v-model.trim="phone_number"
                    type="text"
                    class="validate"
                  >
                  <label for="Phone Number">Phone Number</label>
                  <span v-if="$v.phone_number.$dirty && !$v.phone_number.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="Cell Number"
                    v-model.trim="call_number"
                    type="text"
                    class="validate"
                  >
                  <label for="Cell Number">Cell Number</label>
                  <span v-if="$v.call_number.$dirty && !$v.call_number.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
            </div>
            <div class="col s4">
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="Fax "
                    v-model.trim="fax"
                    type="text"
                    class="validate"
                  >
                  <label for="Fax ">Fax </label>
                  <span v-if="$v.fax.$dirty && !$v.fax.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <el-select
                      v-model="country_id"
                      filterable
                      placeholder="Country"
                      class="select"
                      no-data-text="Lis t is empty"
                      no-match-text="User not found"
                  >
                    <el-option
                        v-for="cl in country_list"
                        :key="cl.id"
                        :value="cl.id"
                        :label="cl.country_name"
                    >
                    </el-option>
                  </el-select>
                  <span v-if="$v.country_id.$dirty && !$v.country_id.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="State \ Province"
                    v-model.trim="state_or_province"
                    type="text"
                    class="validate"
                  >
                  <label for="State \ Province">State \ Province</label>
                  <span v-if="$v.state_or_province.$dirty && !$v.state_or_province.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="City"
                    v-model.trim="city"
                    type="text"
                    class="validate"
                  >
                  <label for="City">City</label>
                  <span v-if="$v.city.$dirty && !$v.city.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <input
                    id="Address"
                    v-model.trim="address"
                    type="text"
                    class="validate"
                  >
                  <label for="Address">Address</label>
                  <span v-if="$v.address.$dirty && !$v.address.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
            </div>
            <button
              class="btn waves-effect waves-light"
              type="submit"
              name="action"
            >
              Registration
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {required, email} from "vuelidate/lib/validators";
  export default {
    name: "Registration",
    validations: {
      login: {required},
      password: {required},
      salutation: {required},
      first_name: {required},
      last_name: {required},
      company_name: {required},
      call_number: {required},
      phone_number: {required},
      email: {required, email},
      date_of_birth : {required},
      fax: {required},
      address: {required},
      city: {required},
      state_or_province: {required},
      country_id: {required},

    },
    data: () => ({
      login: '',
      password: '',
      salutation: '',
      first_name: '',
      last_name: '',
      company_name: '',

      call_number: '',
      phone_number: '',
      email: '',
      date_of_birth : '',
      fax: "",

      address: '',
      city: '',
      state_or_province: '',
      country_id: "",

      message: '',

      country_list: null

    }),
    methods: {
      async onSubmitRegistration() {
        if (this.$v.$invalid) {
          this.$v.$touch();
          return;
        }
        let answer = await this.$store.dispatch('register', {
          login: this.login,
          password: this.password,
          salutation: this.salutation,
          first_name: this.first_name,
          last_name: this.last_name,
          company_name: this.company_name,
          call_number: this.call_number,
          phone_number: this.phone_number,
          email: this.email,
          date_of_birth : this.date_of_birth,
          fax: this.fax,
          address: this.address,
          city: this.city,
          state_or_province: this.state_or_province,
          country_id: this.country_id,
        });

        if (answer > 1) {
          this.$message({
            message: 'User created successfully',
            type: 'success'
          })
        } else {
          this.$message({
            message: answer.message || 'User created error',
            type: 'error'
          })
        }
        this.login = '';
        this.password = '';
      }
    },
    mounted() {
      let cast = Promise.resolve(this.$store.dispatch('request', {
        path: 'admin/gets/countries/lists',
        dody: {}
      }));
      let vm = this;
      cast.then(function (v) {
        vm.country_list = v;
      });

    },
    updated() {
      window.M.FormSelect.init(this.$refs.country_list);
    }
  }
</script>

<style scoped>
  .input-field .helper-text {
    color: red;
  }

  .select {
    width: 100%;
  }
</style>
